(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-supplier-badge"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.product-supplier-badge__info');
  document.querySelectorAll('.product-supplier-badge__info[aria-expanded="true"]').forEach(function (btn) {
    if (btn !== trigger) btn.setAttribute('aria-expanded', 'false');
  });
  if (trigger) {
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  }
});
  } catch(e) { console.error(e); }
})();

})();
